import { CommonModule } from '@angular/common';
import { Component, effect, ElementRef, EventEmitter, inject, Input, Output, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { ITEMS_BAR, TabKey } from '../data/items';

@Component({
  selector: 'lib-promoters-dashboard-tabs',
  imports: [CommonModule],
  templateUrl: './promoters-dashboard-tabs.html',
  styleUrl: './promoters-dashboard-tabs.scss',
})
export class PromotersDashboardTabs{

  private router = inject(Router);

  active = signal<TabKey>('inicio');
  @Output() selected = new EventEmitter<TabKey>();

  private tabContainer = viewChild<ElementRef>('tabContainer');

  constructor() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd), // Solo cuando la navegación terminó con éxito
      takeUntilDestroyed() // Se limpia solo al destruir el componente
    ).subscribe(() => {
      this.updateActiveTab();
    });

    // Ejecución inicial por si entran directo a una URL
    this.updateActiveTab();

    effect(() => {
      const activeKey = this.active();
      // Esperamos un ciclo de micro-task para que el DOM se actualice con la clase .active
      setTimeout(() => this.scrollToActiveTab(), 100);
    });
  }

  readonly items = ITEMS_BAR;

  onTab( key: TabKey, option?: string) {
    if (key === 'reservas'){
      this.active.set(key);
      this.router.navigateByUrl('promotor-member-booking-feature');
      return;
    }
    // this.selected.emit(key);
    this.active.set(key);
    if (!option) return;
    this.router.navigateByUrl(option);
    // localStorage.setItem('pathState', option);
  }

  private updateActiveTab() {
    console.log('Actualizando Ruta');
    const urlSegments = this.router.url.split('/');
    console.log('URL Segments:', urlSegments);
    const lastSegment = urlSegments[urlSegments.length - 1];

    const found = this.items.find(item => item.path === lastSegment);
    if (found) {
      console.log('Ruta encontrada:', found);
      this.active.set(found.key);
      console.log('Active set to:', this.active);
    }
  }

  private scrollToActiveTab() {
    const container = this.tabContainer()?.nativeElement;
    if (!container) return;

    // Buscamos el botón que tiene la clase 'active' dentro de este componente
    const activeTab = container.querySelector('.tab.active') as HTMLElement;

    if (activeTab) {
      activeTab.scrollIntoView({
        behavior: 'smooth', // Desplazamiento fluido
        block: 'nearest',   // Lo mueve lo mínimo necesario verticalmente
        inline: 'center'    // ¡IMPORTANTE! Lo centra horizontalmente en el scroll
      });
    }
  }
}
